const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_public/sign-up.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_public/sign-up')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});